import { userRoles } from "./user";

export const districts = [
  "Patna",
  "Madhepura",
  "Bhagalpur",
  "Araria",
  "Gaya",
  "Gopalganj",
  "Jamui",
  "Kaimur (Bhabua)",
  "Nawada",
  "Samastipur",
  "Siwan",
  "Vaishali",
  "Katihar",
  "Muzaffarpur",
  "Nalanda",
  "Purnia (Purnea)",
  "Sheikhpura",
  "Sitamarhi",
  "Supaul",
  "West Champaran",
  "Aurangabad",
  "Banka",
  "Bhojpur",
  "Buxar",
  "Darbhanga",
  "Kishanganj",
  "Lakhisarai",
  "Saharsa",
  "Sheohar",
  "Arwal",
  "Begusarai",
  "East Champaran (Motihari)",
  "Jehanabad",
  "Khagaria",
  "Madhubani",
  "Munger (Monghyr)",
  "Rohtas",
  "Saran",
];

export const departments = [
  "Cardiology",
  "Interventional Neuro",
  "Neurology",
  "Gyane oncology",
  "CTVS",
  "Surgical oncology",
  "Urology",
  "Neuro surgery",
  "Medical oncology",
  "Nephrology",
];
export const diseases = ["CAG", "PTCA", "Septal Defect"];

export const fileExportType = {
  MS_REPORT: "msReport",
  DIC_REPORT: "dicReport",
  DIC_PENDING_REPORT: "dicPendingReport",
  STAFF_REPORT: "staffReport",
};

export const fileExportDropDown = {
  [userRoles.SUPER_ADMIN]: [
    {
      _id: fileExportType.MS_REPORT,
      name: "MS Report",
    },
    {
      _id: fileExportType.DIC_REPORT,
      name: "DIC Report",
    },
    {
      _id: fileExportType.DIC_PENDING_REPORT,
      name: "DIC Pending Report",
    },
    {
      _id: fileExportType.STAFF_REPORT,
      name: "Staff Report",
    },
  ],
  [userRoles.SURGEON]: [
    {
      _id: fileExportType.MS_REPORT,
      name: "Report",
    },
  ],
  [userRoles.D_C]: [
    {
      _id: fileExportType.DIC_REPORT,
      name: "Report",
    },
    {
      _id: fileExportType.DIC_PENDING_REPORT,
      name: "Pending Report",
    },
  ],
  [userRoles.STAFF]: [
    {
      _id: fileExportType.STAFF_REPORT,
      name: "Report",
    },
  ],
};
